import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "description-area"
}
const _hoisted_2 = { style: {"font-weight":"700","white-space":"nowrap","overflow":"hidden"} }
const _hoisted_3 = { class: "description-space" }
const _hoisted_4 = { style: {"margin-top":"0.5rem","margin-bottom":"0.5rem","white-space":"pre"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserBlock = _resolveComponent("UserBlock")!

  return (_openBlock(), _createBlock(_Transition, { name: "tran-detail" }, {
    default: _withCtx(() => [
      (_ctx.showDescription)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.publicPageData.title), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_UserBlock, {
                dtoUser: _ctx.publicPageData.user
              }, null, 8, ["dtoUser"]),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.publicPageData.description), 1),
              _cache[0] || (_cache[0] = _createElementVNode("div", { style: {"display":"flex"} }, null, -1))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}